import "@/App.css";
import React from "react";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import { Marquee } from "@/lib/motion";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Finishes from "@/components/site/Finishes";
import Machinery from "@/components/site/Machinery";
import Sectors from "@/components/site/Sectors";
import Gallery from "@/components/site/Gallery";
import Sampling from "@/components/site/Sampling";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppButton from "@/components/site/WhatsAppButton";
import { useLang } from "@/i18n";

const Page = () => {
  const { t } = useLang();
  return (
    <div className="relative min-h-screen bg-[#0A0A0A] noise-overlay">
      <Header />
      <main>
        <Hero />
        <Marquee text={t.marquee} />
        <About />
        <Services />
        <Finishes />
        <Machinery />
        <Sectors />
        <Gallery />
        <Sampling />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <Page />
        <Toaster
          position="top-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#121212",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "#F4F4F5",
              borderRadius: "0",
            },
          }}
        />
      </ReactLenis>
    </LanguageProvider>
  );
}

export default App;
